/* @flow */
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import React, {Component} from 'react';
import App from '../App';
import {injectIntl} from 'react-intl';
const AppWithIntl = injectIntl(App);

type Props = {
	locale : string,
	match: Object,
	environment: string,
	history: Object
};

class QuickActionsView extends Component<Props> {
	constructor(props: Object) {
		super(props);
		// set the enviornment
		window.ENV = this.props.environment;
	}

	render() {
			return (
					<AppWithIntl { ...this.props } />
			);
	}
}

export default QuickActionsView;